import type { SVGProps } from "react";
import * as React from "react";

const SvgColumns = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 3v18m0-18h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7zm0 0H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7z"
    />
  </svg>
);
export default SvgColumns;
